export const getMe = state => state.me
export const isAdmin = state => state.me.role === 'ADMIN'
export const getVacations = state => state.vacations
export const getHolidays = state => state.holidays
export const getNewVacations = state => state.newVacations
export const getNewHolidays = state => state.newHolidays
export const getStartDate = state => state.startDate
export const getEndDate = state => state.endDate
export const getBookedDays = state => state.bookedDays
export const getShowMore = state => state.showMore
export const getCurrentView = state => state.currentView
export const getSelectDay = state => state.selectDay
export const getSelectedYear = state => state.selectedYear
export const getEditingId = state => state.editingId
export const getUpdateVacations = state => state.updateVacations
export const getUpdateHolidays = state => state.updateHolidays
export const getApiError = state => state.apiError
export const getAvailableDays = state => state.availableDays
export const getKaleiders = state => state.kaleiders
export const getImportSuccess = state => state.importVacationsSuccess



// WEBPACK FOOTER //
// ./src/vuex/getters.js